import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Vote from '../views/vote/index.vue';
import AntigensLists from '../views/antigensLists/index.vue';
import Records from '../views/records/index.vue';
import convertDetail from '../views/convertDetail/index.vue'
import LoginTip from '../views/loginTip/index.vue'
import CouponLists from '../views/couponLists/index.vue'
import CouponDetail from '../views/couponDetail/index.vue'
import CouponRecords from '../views/couponRecords/index.vue'
import CbaTicketLists from '../views/cbaTicketLists/index.vue'
import CbaTicketDetail from '../views/cbaTicketDetail/index.vue'
import CbaTicketRecords from '../views/cbaTicketRecords/index.vue'
import ExposureLists from '../views/exposureLists/index.vue'
import ExposureDetail from '../views/exposureDetail/index.vue'
import ExposureSave from '../views/exposureSave/index.vue'
import DeepseekQuestion from '../views/deepseekQuestion/index.vue'
import Beianhao from '../views/beianhao/index.vue'
import Dycbalist from '../views/dycbalist/index.vue'
import Dycbaexchange from '../views/dycbaexchange/index.vue'
import Dycbaexchangerecode from '../views/dycbaexchangerecode/index.vue'
import DycbaCommentList from '../views/dycbaCommentList/index.vue'
import DyBookShop from '../views/dyBookShop/index.vue'
import DyBookShopDetail from '../views/dyBookShopDetail/index.vue'
import DyBookShopRecords from '../views/dyBookShopRecords/index.vue'
import DyBookShopNumberCreate from '../views/dyBookShopNumberCreate/index.vue'
import OurHoliday from '../views/ourHoliday/index.vue'
import PlayScoreRanking from '../views/playScoreRanking/index.vue'

// import Home from '../views/Home.vue'

import TaxUserIDConfirm from '../views/housePropertyTax/user-id-confirm/index.vue'
import TaxDepartmentSelection from '../views/housePropertyTax/department-selection/index.vue'
import TaxBusinessSelection from '../views/housePropertyTax/business-selection/index.vue'
import TaxDateTimeSelection from '../views/housePropertyTax/date-time-selection/index.vue'
import TaxAppointmentRecord from '../views/housePropertyTax/appointment-record/index.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Vote',
    component: Vote,
    meta: {
      title: '投票'
    }
  },//投票
  {
    path: '/antigensLists',
    name: 'AntigensLists',
    component: AntigensLists,
    meta: {
      title: '门票秒杀'
    }
  },//抗原抢兑
  {
    path: '/convertDetail',
    name: 'ConvertDetail',
    component: convertDetail,
    meta: {
      title: '兑换详情'
    }

  },//兑换详情

  {
    path: '/records',
    name: 'Record',
    component: Records,
    meta: {
      title: '兑换记录'
    }

  },//兑换记录
  {
    path: '/loginTip',
    name: 'LoginTip',
    component: LoginTip,
    meta: {
      title: '登录页面提示'
    }

  },//登录页面提示
  {
    path: '/couponLists',
    name: 'CouponLists',
    component: CouponLists,
    meta: {
      title: '消费券'
    }

  },//券列表
  {
    path: '/couponDetail',
    name: 'CouponDetail',
    component: CouponDetail,
    meta: {
      title: '详情'
    }

  },

  {
    path: '/couponRecords',
    name: 'CouponRecords',
    component: CouponRecords,
    meta: {
      title: '兑换记录'
    }

  },

  // 2023-24赛季中国男子篮球职业联赛江苏肯帝亚丹阳主场
  {
    path: '/cbaTicketLists',
    name: 'CbaTicketLists',
    component: CbaTicketLists,
    meta: {
      title: '粉丝福利'
    }

  },
  {
    path: '/cbaTicketDetail',
    name: 'CbaTicketDetail',
    component: CbaTicketDetail,
    meta: {
      title: '粉丝福利'
    }

  },//报名详情

  {
    path: '/cbaTicketRecords',
    name: 'CbaTicketRecords',
    component: CbaTicketRecords,
    meta: {
      title: '中奖记录'
    }

  },//中奖记录

  {
    path: '/taxUserIDConfirm',
    name: 'TaxUserIDConfirm',
    component: TaxUserIDConfirm,
    meta: {
      title: '实名认证'
    }
  },//房产税预约实名认证

  {
    path: '/taxDepartmentSelection',
    name: 'TaxDepartmentSelection',
    component: TaxDepartmentSelection,
    meta: {
      title: '在线预约'
    }
  },//房产税在线预约部门选择
  {
    path: '/taxBusinessSelection',
    name: 'TaxBusinessSelection',
    component: TaxBusinessSelection,
    meta: {
      title: '在线预约'
    }
  },//房产税在线预约业务选择
  {
    path: '/taxDateTimeSelection',
    name: 'TaxDateTimeSelection',
    component: TaxDateTimeSelection,
    meta: {
      title: '选择预约时间'
    }
  },//房产税在线预约时间选择
  {
    path: '/taxAppointmentRecord',
    name: 'TaxAppointmentRecord',
    component: TaxAppointmentRecord,
    meta: {
      title: '预约记录'
    }
  },//房产税预约记录
  {
    path: '/exposureLists',
    name: 'ExposureLists',
    component: ExposureLists,
    meta: {
      title: '在线举报'
    }
  },//新闻页面内的举报功能
  {
    path: '/exposureSave',
    name: 'ExposureSave',
    component: ExposureSave,
    meta: {
      title: '我要举报'
    }
  },
  {
    path: '/exposureDetail',
    name: 'ExposureDetail',
    component: ExposureDetail,
    meta: {
      title: '情况简介'
    }
  },
  {
    path: '/beianhao',
    name: 'Beianhao',
    component: Beianhao,
    meta: {
      title: '备案号'
    }
  },
  {
    path: '/dycbalist',
    name: 'Dycbalist',
    component: Dycbalist,
    meta: {
      title: 'CBA丹阳赛区'
    }
  },
  {
    path: '/dycbaexchange',
    name: 'Dycbaexchange',
    component: Dycbaexchange,
    meta: {
      title: '积分兑换'
    }
  },
  {
    path: '/dycbaexchangerecode',
    name: 'Dycbaexchangerecode',
    component: Dycbaexchangerecode,
    meta: {
      title: '兑换记录'
    }
  },
  {
    path: '/dycbaCommentList',
    name: 'DycbaCommentList',
    component: DycbaCommentList,
    meta: {
      title: '评论互动'
    }
  },
  {
    path: '/dyBookShop',
    name: 'DyBookShop',
    component: DyBookShop,
    meta: {
      title: '丹阳书房'
    }
  },
  {
    path: '/dyBookShopDetail',
    name: 'DyBookShopDetail',
    component: DyBookShopDetail,
    meta: {
      title: '书房券详情'
    }
  },
  {
    path: '/dyBookShopRecords',
    name: 'DyBookShopRecords',
    component: DyBookShopRecords,
    meta: {
      title: '书房券兑换记录'
    }
  },
  {
    path: '/dyBookShopNumberCreate',
    name: 'DyBookShopNumberCreate',
    component: DyBookShopNumberCreate,
    meta: {
      title: '丹阳书房券生成'
    }
  },
  {
    path: '/ourHoliday',
    name: 'OurHoliday',
    component: OurHoliday,
    meta: {
      title: '网络中国节'
    }
  },
  {
    path: '/playScoreRanking',
    name: 'PlayScoreRanking',
    component: PlayScoreRanking,
    meta: {
      title: '2026丹阳市“村BA”'
    }
  },
  {
    path: '/deepseekQuestion',
    name: 'DeepseekQuestion',
    component: DeepseekQuestion,
    meta: {
      title: 'deepseek'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// router.beforeEach((to, from, next) => {
//   const { meta = {} } = to
//   const isLoggedIn = Store.getters['user/isLoggedIn'] // 是否已登录
//   const isUserInfoComplete = Store.getters['user/isUserInfoComplete'] // 用户信息是否填写完整
//   if (meta.unrequireLogin) {
//     // 不需要登录
//     next(true)
//   } else if (!isLoggedIn) {
//     // 没有登录信息，去登录页面
//     next({ name: 'Login' })
//   } else if (meta.unrequireRegister) {
//     // 不需要完善信息的页面
//     next(true)
//   } else if (!isUserInfoComplete) {
//     // 需要完善用户信息的页面
//     next({ name: 'Register' })
//   } else {
//     // 正常页面
//     next(true)
//   }
// })

export default router
